export const FETCH_TELEMETRY_REQUEST = 'FETCH_TELEMETRY_REQUEST';
export const FETCH_TELEMETRY_SUCCESS = 'FETCH_TELEMETRY_SUCCESS';
export const FETCH_TELEMETRY_FAILED = 'FETCH_TELEMETRY_FAILED';

export const FETCH_UPDATE_TELEMETRY_REQUEST = 'FETCH_UPDATE_TELEMETRY_REQUEST';
export const FETCH_UPDATE_TELEMETRY_SUCCESS = 'FETCH_UPDATE_TELEMETRY_SUCCESS';
export const FETCH_UPDATE_TELEMETRY_FAILED = 'FETCH_UPDATE_TELEMETRY_FAILED';

export const FETCH_RESET_UPDATE_TELEMETRY_FAILED = 'FETCH_RESET_UPDATE_TELEMETRY_FAILED';
